<template>
<div id="app">
 <v-app id="inspire" :style="[loading === true ? { 'opacity':'0.4', 'margin': '0px 0px -37px 120px;' , 'position': 'relative' } : { 'background':'none', 'margin': '0px 0px -37px 120px;' , 'position': 'relative'}]" >
    <br/>
     <v-row >
         <v-col col="12"> 
             <v-card style="background-color:#ef3e42;"
                     color="#ef3e73"
                     dark
                     >
                 <v-card-title class="text-h5">{{titleMain}}</v-card-title> 
                 <v-card-text id="descriptionTitle"><span></span></v-card-text>
             </v-card>
         </v-col>
     </v-row>
     <v-row>
         <div  v-for="(item, index) in xmlArray" xl="4" lg="4" md="8" sm="12" xs="12">   
        	<v-col xl="4" lg="4" md="8" sm="12" xs="12">
                <v-card  style="background-color:#ffd24f;"
                  class="mx-auto"
                  max-width="400"
                  width="383"
                 >
                  <v-img style = "background-size: auto !important;"
                         :src="item.imageOfstory"
                          height="200px"
                   ></v-img>
                  <v-card-title class="pb-0 font-weight-medium"  :title="item.title"> 
                      <p v-if="item.countStrTitle > 35" style="font-size: 16px; white-space: nowrap;overflow: hidden;text-overflow:  ellipsis;  color:#003F91;">{{item.title}}...</p>
                      <p v-else style="font-size: 16px;color:#003F91;">{{item.title}}</p>
                    </v-card-title>
                  <v-card-text class="pb-0" style="font-size: 12px; color:#5DA9E9;">
                    <div>Senast uppdaterad : {{item.pubDate}}</div>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn style="font-size: 12px;"
                      color="#6D326D"
                      text    
                     v-on:click="showDialog(true,item)"
                    >
                      läs mer
                    </v-btn>
                    <v-btn style="font-size: 12px;"
                      :href=item.link     
                      target = "_blank"     
                      color="#6D326D"
                      text
                    >
                     besök hemsidan
                    </v-btn>
                  </v-card-actions>
                </v-card>
             
             </v-col>
        </div>
        <br/><br/><br/>
    </v-row>
     <v-dialog v-model="showmodel" width="60%">
         <v-card >
          <v-card-title class="text-h5 lighten-2" style="background-color:#6D326D; color:#FFFFFF;">
            <b>{{titleText}}</b>
          </v-card-title>
  
          <v-card-text  style="text-indent: 1.5em; background-color:#FBFAF8; color: #0A122A;">
              <br/>
          <!-- {{descriptionText}} -->
              <div id="list"></div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="color: #FBFAF8;"
              color="#6D326D"
              v-on:click="closeDialog(false)"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> 
  </v-app> 
    <br/><br/>
    
<v-app id="inspire">
<v-row>  
    <v-col> 
        <div class="text-center" style="margin: 20px 0 0 0;    position: relative;">
           
            <v-pagination
                          @input="loadDataFirst(page)"           
                          v-model="page"
                          :length="amountPagtination"
                          :total-visible="7"
                          class="my-4"
                          prev-icon="mdi-menu-left"
                          next-icon="mdi-menu-right"
                          circle            
                          ></v-pagination>
        </div>
        </v-col> 
    </v-row>   
  </v-app>
</div>
 </template>
<script>export default {
    zoezi: {
      icon: 'mdi-sheep'
    },
    props: {
      perpage: {
        title: 'Amount cards per page',
        type: Number,
        default: 5
      },
      urlrsslink:{
      	title : 'Link for RSS news feed',
        type:String,
            default: 'https://www.svenskorientering.se/Nyheter/forbundsnytt/?rss=True'
      },
    },
    data: () => ({
        show: false,
        timer1 : '',
        timer2: '',
        articlesArray: [],
        articlesArray2: [],
        page : 1,
        numrows : 10,
        amountPagesList : 0,
        dialog: false,
        listpageDefault : 0,
        articlesArrayFilter : [],
        onclickIndex : 0,
        loading : false,
        dialog: false,
        showmodel: false,
        descriptionText : '',
        titleText : '',
        styleTextTitle : '',
        xmlArray : [],
        amountPagtination : [],
        noImage : 'https://www.img.in.th/images/aa6559a1f27a604e3c0b34b372bf4056.png',
        titleMain : '',
        titleDescription : ''
    }),
    methods: {
        showDialog : async function(item,data){
            this.descriptionText =  '' ;  
            this.showmodel = item;
            await setTimeout(()=>{
                document.getElementById("list").innerHTML = '';  
                setTimeout(()=>{
                    let hostURL = window.location.origin;
                    this.titleText= data.title;
                    this.descriptionText =  data.content ; 
                    document.getElementById("list").innerHTML = this.descriptionText ;
                },500)
            },70)
        },
        closeDialog(item){
            this.showmodel = item;
        },     
        loadDataFirst : async function (){
            this.loading = true;
            let urlPart = this.urlrsslink;
            let articlaesArrayList = this. articlesArray;
            let listPerPage = this.amountPagesList;
            var allpageAmount = []
            let perPage = this.perpage;
            let page = this.page; //page at number
            let perv_page = page -1;
            let next_page = page +1;
            let pageStart = ((perPage*page)-perPage) + 1;
            let numrows =  this.amountPagesList;
            let numPageRead = 0; 

            if(numrows<=perPage){
                numPageRead = 1;   
            }else if((numrows%perPage)==0){
                numPageRead = (numrows/perPage);   
            }else{
                numPageRead = (numrows/perPage)+1;
                numPageRead = parseInt(numPageRead);
            }
            var perNum = 0;
            for( var num = 1; num <= numPageRead; num++){
                if(num != page)
                {
                    perNum = num;
                }
                else
                {
                    perNum = num;
                }
            }
            let  articlesArrayX = [];
            let articlesArrayX2 = [];
            
            var htmlHttp = new XMLHttpRequest();
            htmlHttp.open("GET", this.urlrsslink, true);
            htmlHttp.onreadystatechange =  () => {
                if (htmlHttp.readyState == 4 && htmlHttp.status == 200)
                {
                    var doc = htmlHttp.responseXML;
                    var channel = doc.getElementsByTagName("channel");
                    channel.forEach((itemChanel)=>{
                        var itemTags = itemChanel.getElementsByTagName("item");
                        this.titleMain = itemChanel.getElementsByTagName("title")[0].textContent;
                        this.titleDescription = itemChanel.getElementsByTagName("description")[0].textContent;
                        setTimeout(()=>{
                            document.getElementById("descriptionTitle").innerHTML = this.titleDescription ;
                        },500)
                        var num = 1;
                        itemTags.forEach((itemT)=>{
                            let getTitle = itemT.getElementsByTagName("title")[0];
                            let getLink = itemT.getElementsByTagName("link")[0]
                            let getDescription = itemT.getElementsByTagName("description")[0];
                            let getPubDate = itemT.getElementsByTagName("pubDate")[0];
                            let getImage = itemT.getElementsByTagName("image")[0];
                            let d = new Date(getPubDate.textContent);
                            let day = d.getDay();
                            let month = d.getMonth();
                            let years = d.getFullYear(); // 12 december 2022

                            let monthList = ["01","02","03","04","05","06","07","08","09","10","11","12"];
                            let namemonthList = monthList[month];
                            let fullDate = years  +  '-' + namemonthList + '-' + this.number1digiTo2digi(day);

                            let newR =
                                {
                                    id: num++ ,
                                    title :getTitle.textContent,  
                                    link :getLink.textContent , 
                                    content: getDescription.textContent, 
                                    pubDate :fullDate, 
                                    countStrTitle : getTitle.textContent.length,
                                    imageOfstory : getImage ? getImage.textContent : this.noImage
                                }

                            for(var i = pageStart; i<= (pageStart+perPage)-1; i++){
                                if(newR.id === i){
                                    articlesArrayX.push(newR);
                                }
                            }
                            articlesArrayX2.push(newR);
                        });

                        this.articlesArray = articlesArrayX;
                        let resultAmount = articlesArrayX2.length / perPage;
                        if(resultAmount < 1){
                            this.amountPagesList = 1;
                        }else{
                            if(!Number.isInteger(resultAmount)){
                                this.amountPagesList = Math.ceil(resultAmount);
                            }else{
                                this.amountPagesList = resultAmount;
                            }
                        }
                        this.getJsonToTemplate( this.amountPagesList,articlesArrayX);
                        this.loading = false;
                    });
                    return articlesArrayX;
                }
            };
            htmlHttp.send(null);
        },
        getJsonToTemplate(amountPagesList,articlesArray){
            this.amountPagtination = amountPagesList;
            this.xmlArray = articlesArray;
        },
        number1digiTo2digi(number){
            if(number < 10){
                var number2digi = "0" + number.toString();
            }else{
                var number2digi =  number.toString();
            }
            return number2digi
        },
        processSytleMethods : async function(){
            this.loading = true;
            this.showmodel= false;
            let st = document.createElement('link');
            st.setAttribute('type', "text/css");
            st.setAttribute('rel', "stylesheet");
            st.setAttribute('href', 'https://cdnjs.cloudflare.com/ajax/libs/vuetify/2.6.1/vuetify.css');
            document.head.appendChild(st);
            let s = document.createElement('script');
            s.setAttribute('src', 'https://cdn.jsdelivr.net/npm/rss-parser@3.7.6/dist/rss-parser.min.js');
            document.head.appendChild(s);
            this.loading = false;
         },
      
    },
  	mounted() {
         this.timer1 = setTimeout(() => {
             this.processSytleMethods();
             this.loadDataFirst();
         }, 300);
	},
    beforeDestroy() {
         clearTimeout(this.timer1);
         clearTimeout(this.timer2);
      },
}</script>